import { IsInt, IsOptional, IsString, Max, MaxLength, Min, MinLength } from "class-validator";
import { Type } from "class-transformer";

export const GLOBAL_SEARCH_MIN_QUERY = 2;
export const GLOBAL_SEARCH_MAX_QUERY = 64;
export const GLOBAL_SEARCH_DEFAULT_LIMIT = 5;
export const GLOBAL_SEARCH_MAX_LIMIT = 10;

export class GlobalSearchQueryDto {
  @IsString()
  @MinLength(GLOBAL_SEARCH_MIN_QUERY)
  @MaxLength(GLOBAL_SEARCH_MAX_QUERY)
  q: string;

  /** Per type. The response holds at most 4 × limit results. */
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(GLOBAL_SEARCH_MAX_LIMIT)
  limit?: number = GLOBAL_SEARCH_DEFAULT_LIMIT;
}
